import { render, staticRenderFns } from "./Planfeed.vue?vue&type=template&id=5ad0b258&lang=pug&"
import script from "./Planfeed.vue?vue&type=script&lang=js&"
export * from "./Planfeed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports